export enum DocumentBulkUpdateActionType {
  HOLD = 1,
  ASSIGN = 2,
  REMOVE = 3,
}
